import { UserPresence } from './types'
import { find, get, set, remove, cloneDeep } from 'lodash'
import { Events } from '../../../models/event/events'

type PresenceChange = { user: UserPresence; event: string; order_id: string }

export const applyOrderPresenceChange = (userPresences: object, data: PresenceChange): object => {
  const next = cloneDeep(userPresences || {})
  const orderUsers = get(next, data.order_id)
  const existingUser = find(orderUsers, (user: UserPresence) => user.id === data.user.id)

  switch (data.event) {
    case Events.MemberAdded:
      if (!existingUser) {
        if (orderUsers) {
          orderUsers.push(data.user)
        } else {
          set(next, data.order_id, [data.user])
        }
      }
      break
    case Events.MemberRemoved:
      remove(orderUsers, existingUser)
      break
  }

  return next
}

// Updates from the previous state rather than a captured copy, so the handler stays valid
// for the life of the subscription and its effect never needs userPresences as a dependency.
export const sharedOrderPresenceChangeCallback = (data: PresenceChange, setUserPresences: Function) => {
  setUserPresences((previous: object) => applyOrderPresenceChange(previous, data))
}
